var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-composable-checkpoint", {
    class: { enabled: _vm.isEnabled },
    style: { "user-select": this.isEnabled && _vm.canWrite ? "auto" : "none" },
    attrs: {
      draggable: _vm.isEnabled && _vm.canWrite,
      name: _vm.checkpoint.displayName
    },
    nativeOn: {
      click: function($event) {
        return _vm.toggleFocusMode()
      }
    },
    scopedSlots: _vm._u([
      {
        key: "top",
        fn: function() {
          return [
            _c("notification-circle", {
              attrs: {
                "notification-count": _vm.filterExclusionCheckpointsCount
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "icon",
        fn: function() {
          return [
            _c("span", { staticClass: "fa-stack fa-1x" }, [
              _c("i", {
                staticClass: "fa-stack-1x",
                class: _vm.checkpoint.iconClass
              }),
              _vm._v(" "),
              _c("i", { staticClass: "fas fa-ban fa-stack-2x" })
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }